<div class="input" [formGroup]="formGroup" [class.invalid]="hasError">
  <div class="input-header">
    <div class="label-help-text">
      <div class="label-container2">
        <div class="label-wrapper">
          <div class="email-label">{{label | translate}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="input-field">
    @if (isPassword && type === 'text') {
    <button type="button" class="show-password" (click)="toggleShowPassword()">
      <app-icon-eye [slashed]="true" />&nbsp;
      <span>{{ 'input.hidePassword' | translate }}</span>
    </button>
    } @else if (isPassword && type === 'password') {
    <button type="button" class="show-password" (click)="toggleShowPassword()">
      <app-icon-eye />&nbsp;
      <span>{{ 'input.showPassword' | translate }}</span>
    </button>
    }
    <input [id]="name" [type]="type" [formControlName]="name"
      [class]="'mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none ' +
               (hasError ? 'invalid border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500')"
      [required]="required" />
  </div>
</div>
